import React from 'react'

import './toast6.css'

const Toast6 = (props) => {
  return (
    <div className="toast6-container">
      <div className="toast6-header"></div>
    </div>
  )
}

export default Toast6
